// Einbindung über npm oder per js
S.videoJs =
    {
        init()
        {
            if (this.instance === 0)
            {
                this.loadCss();
                this.loadJs();
            }
        },

        loadCss()
        {
            $('head').append('<link rel="stylesheet" href="/assets/css/videojs.min.css">');
        },

        loadJs()
        {
            $.getScript('/assets/js/videojs.min.js', function ()
            {
                // Dieser Callback wird nach dem erfolgreichen Ladevorgang ausgeführt
            });
        },
    };
